import React from 'react';
import { Users, Target, TrendingUp } from 'lucide-react';
import { targetAudience } from '../mock';

const TargetAudience = () => {
  return (
    <section className="py-24 px-6 bg-[#050812]">
      <div className="max-w-5xl mx-auto">
        <div className="text-center space-y-6 mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-500/10 border border-cyan-500/20 rounded-full text-cyan-400 text-sm font-medium mb-4">
            <Target className="w-4 h-4" />
            Built For Engineers
          </div>
          <h2 className="text-4xl md:text-5xl font-bold">
            Who Should{' '}
            <span className="bg-gradient-to-r from-cyan-400 to-blue-500 bg-clip-text text-transparent">
              Use SystemCraft?
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {targetAudience.map((audience, index) => (
            <div
              key={index}
              className="group p-8 bg-gradient-to-br from-gray-900/50 to-gray-800/30 border border-gray-800 rounded-xl hover:border-cyan-500/50 transition-all duration-300 hover:shadow-xl hover:shadow-cyan-500/10"
            >
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-cyan-500/20 rounded-full flex items-center justify-center flex-shrink-0 group-hover:bg-cyan-500/30 transition-colors">
                  <div className="w-2 h-2 bg-cyan-400 rounded-full"></div>
                </div>
                <p className="text-gray-300 leading-relaxed">{audience}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 p-8 bg-gradient-to-r from-cyan-500/10 to-blue-600/10 border border-cyan-500/20 rounded-2xl">
          <div className="flex items-start gap-6">
            <div className="w-12 h-12 bg-cyan-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
              <TrendingUp className="w-6 h-6 text-cyan-400" />
            </div>
            <div>
              <h3 className="text-2xl font-bold mb-3 text-white">
                Built around real interview expectations
              </h3>
              <p className="text-gray-400 text-lg leading-relaxed">
                SystemCraft is focused on reasoning and trade-offs, not just box-drawing. 
                Practice the way you'll be tested.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TargetAudience;
